import { Close } from "@lazarentertainment/web-design-system/components/iconOutline"
import { useLayoutContext } from "client/components/layout"
import { Button } from "client/designSystem/Button"
import { Sheet } from "client/designSystem/Sheet"
import {
  Plugin,
  useGlobalContext,
} from "client/packages/utils/GlobalContext"
import { ErrorBoundary } from "shared/components/ErrorBoundary"
import { RozyLayout } from "shared/constants/views"

import { CommerceError } from "../utils/components/CommerceError"

import {
  CommerceHeaderBackButton,
  useCommerceHeaderDescription,
  useCommerceHeaderTitle,
} from "./ui/CommerceHeader"
import CommerceFlow from "./CommerceFlow"
import { useShopContext } from "./ShopContext"

import styles from "./commerceMobileSheet.module.css"

export const CommerceMobileSheet = () => {
  const {
    state: { isCommercePluginOpen },
  } = useGlobalContext()
  const { shop } = useShopContext()
  const { layout } = useLayoutContext()
  const { setPluginOpen } = useGlobalContext()

  const sheetTitle = useCommerceHeaderTitle()
  const sheetDescription = useCommerceHeaderDescription()

  return (
    <Sheet
      open={layout === RozyLayout.MOBILE && isCommercePluginOpen}
      data-layout={layout}
      className={styles.commerceSheet}
      title={sheetTitle}
      description={sheetDescription}
      topLeftContent={<CommerceHeaderBackButton />}
      topRightContent={
        <Button
          variant="tertiary-gray"
          iconOnly
          icon={Close}
          onClick={() => {
            setPluginOpen(Plugin.COMMERCE, false)
          }}
          data-robot="commerce-mobile-close"
        />
      }
    >
      <div className={styles.commerceMobileSheetContent}>
        <ErrorBoundary fallback={<CommerceError />}>
          <CommerceFlow shop={shop} />
        </ErrorBoundary>
      </div>
    </Sheet>
  )
}
